<script setup>
  import { onUnmounted } from "vue";
  import { usePricerProjectStore } from "@stores/pricer/pricerProject";

  const { resetProject } = usePricerProjectStore();

  onUnmounted(() => resetProject());
</script>

<template>
  <RouterView />
</template>
